export const mestplaceTermsAndConditionsAcceptedCookie =
  'MestplaceTermsAndConditionsAcceptedCookie';
